/**
 * CampaignRoomPage — Sprint 4 · Project Symphony
 *
 * Route: /campaigns/:blueprintId/room
 *
 * Patch 34.1.12 — uses the shared WorkspaceGate so the founder never
 * gets punted to /welcome on a transient loading state (root cause of
 * the "We couldn't load this campaign" + perceived logout loop).
 */
import { CampaignRoomView } from "@/features/campaign-room";
import { WorkspaceGate } from "@/widgets/WorkspaceGate/WorkspaceGate";

export default function CampaignRoomPage(): JSX.Element {
  return <WorkspaceGate>{() => <CampaignRoomView />}</WorkspaceGate>;
}
